import {
  IAsgMemberResponseDto,
  IAsgResponseDto,
} from 'components/AutoscalingGroups/types/api-bodies.types';

export enum ActionTypes {
  SET_LIST = 'asg: set-list',
  SET_MEMBERS = 'asg: set-members',
  SET_LOADING = 'asg: set-loading',
  SET_FAILED = 'asg: set-failed',
}

export interface IAsgState {
  list: Array<IAsgResponseDto>;
  // Участники по id группы: список ВМ группы приходит отдельным запросом
  members: Record<number, Array<IAsgMemberResponseDto>>;
  loading: boolean;
  failed: boolean;
}
